import { B2CPolicy, IEnvironmentVariables } from 'src/environments/IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    signUpSignInRegence: 'B2C_1A_SignUp_SignIn_Regence',
    signUpSignInportalextsso: 'B2C_1A_SignUp_SignIn_portalextsso',
    resetPassword: 'B2C_1A_PasswordReset',
  },
  authorityBaseUrl: 'https://mncportalstage.b2clogin.com/tfp/mncportalstage.onmicrosoft.com',
};

const BASE_URL = 'https://portalstg.mynexuscare.com/';

const API_URL = {
  Platform: 'https://api-platform.portalstg.mynexuscare.com',
  HH: 'https://api-homehealth.portalstg.mynexuscare.com',
  PAC: 'https://api-pacim.portalstg.mynexuscare.com',
  DMEPOS: 'https://api-dmepos.portalstg.mynexuscare.com',
  SDoH: 'https://api-sdoh.portalstg.mynexuscare.com',
  SP: 'https://api-specialtyprograms-gateway.portalstg.mynexuscare.com',
  DocumentGateway: 'https://api-document-gateway.portalstg.mynexuscare.com',
  NotificationGateway: 'https://api-notification-gateway.portalstg.mynexuscare.com',
};

const consentScopes = [
  'https://mncportalstage.onmicrosoft.com/api/api.Write',
  'https://mncportalstage.onmicrosoft.com/api/api.Read',
  'https://mncportalstage.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: true,
  b2cPolicies: b2cPolicies,
  baseUrl: BASE_URL,
  appInsightsConnectionString: 'InstrumentationKey=d2c7f7a6-5afa-4238-b9f1-95d3a1a1c7b2;IngestionEndpoint=https://eastus-6.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=110a6382-f05b-476a-8930-d49c233d76b2',
  apiUrl: API_URL.HH,
  apiPlatformUrl: API_URL.Platform,
  apiDocumentUrl: API_URL.DocumentGateway,
  apiUrlPacIM: API_URL.PAC,
  apiDMEPOSUrl: API_URL.DMEPOS,
  apiSDoHUrl: API_URL.SDoH,
  apiSpecialtyProgramsUrl: API_URL.SP,
  apiNotificationsUrl: API_URL.NotificationGateway,
  routerUrl: 'https://resourcerouter.portalstg.mynexuscare.com',
  sdohUrl: 'https://sdoh.portalstg.mynexuscare.com/',
  codeManagementUrl: 'https://web-codemanagement.portalstg.mynexuscare.com',
  extssoBaseUrl: 'https://extsso.portalstg.mynexuscare.com/',
  hhProviderFinderUrl : 'https://carelonsolutions--full.sandbox.my.salesforce-sites.com/ProviderFinder',
  authConfig: {
    config: {
      auth: {
        clientId: '496df1ed-7487-4ac2-a958-3fbaeddaedf2',
        postLogoutRedirectUri: BASE_URL,
        redirectUri: BASE_URL,
        knownAuthorities: ['mncportalstage.b2clogin.com'],
      },
      system: {},
    },
    angularConfig: {
      extraQueryParameters: {
        prompt: 'select_account',
      },
      consentScopes: [...consentScopes, 'openid', 'profile'],
      protectedResourceMap: [
        ...Object.values(API_URL).map((url) => [`${url}/*`, consentScopes]),
      ],
    },
  },
  registryUrl: `${API_URL.Platform}/api/app-registry`,
};


